import classNames from 'classnames';

import { DerivativesOrderStatus, DerivativesPositionCloseType } from 'common/api/autogenerated/trading-gateway';

export const getWrapperClassName = (
  isBuy: boolean,
  isSell: boolean,
  isRow: boolean,
  isColumn: boolean,
  isActive: boolean,
) =>
  classNames('derivative-order Body2_reg_12', {
    'derivative-order--column border-marker--bold': isColumn,
    'derivative-order--row': isRow,
    'derivative-order--row-active': isRow && isActive,
    'border-marker--buy': isBuy,
    'border-marker--sell': isSell,
  });

export const getOpenedDataClassNames = (isColumn: boolean) =>
  classNames({
    'derivative-order-pair-info__opened': true,
    'derivative-order-pair-info__opened--column': isColumn,
  });

export const getHourDataClassNames = (isColumn: boolean) =>
  classNames({
    'derivative-order-pair-info__opened-values': true,
    'derivative-order-pair-info__opened-values--column': isColumn,
  });

export const getCardRowValueClassNames = (
  isRow: boolean,
  isColumn: boolean,
  isGreen = false,
  isRed = false,
  isBold = false,
) =>
  classNames({
    'derivative-order-data__value': true,
    'derivative-order-data__value--column': isColumn,
    'derivative-order-data__value--row': isRow,
    'derivative-order-data__value--green': isGreen,
    'derivative-order-data__value--red': isRed,
    'derivative-order-data__value--bold': isBold,
  });

export const getFeeValueClassNames = (isRow: boolean, isColumn: boolean) =>
  classNames(getCardRowValueClassNames(isRow, isColumn), {
    'derivative-order-data__value-fee': true,
  });

export const closeTypeClassNames = (
  closeType?: DerivativesPositionCloseType | DerivativesOrderStatus,
  isRow?: boolean,
) =>
  classNames({
    'derivative-order-pair-info__close-type': true,
    'derivative-order-pair-info__close-type--row': isRow,
    [`derivative-order-pair-info__close-type--${closeType?.toLowerCase()}`]: closeType,
  });
